import { contextIdConfig } from '../config';
import { useAuthMutation } from '../../common/apiUtils/queryHelper';
import { TCreateScopedContextPayload } from '../types/types';
import { useQueryClient } from 'react-query';

const {
  edit_scoped_context: { url, scope },
  get_scoped_contexts,
} = contextIdConfig;

export const useEditScopedContext = ({
  sitecoreContextId,
  scopeId,
}: {
  sitecoreContextId: string;
  scopeId: string;
}) => {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance) => (payload: Partial<TCreateScopedContextPayload>) =>
      axiosInstance?.patch(url(sitecoreContextId, scopeId), payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          get_scoped_contexts.queryKey(sitecoreContextId),
        );
      },
    },
    scope,
  );
};
